/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './enableJoinLink.defs'
export { main as default } from './enableJoinLink.defs'
